<section *ngIf="!isEnquiryPage" class="support-section">
  <div
    class="container d-flex flex-wrap gap-2 justify-content-between align-items-center p-2"
    id="targetSection"
  >
    <div class="support-header text-white">
      <h2>Need Support?</h2>
      <p>Reach out to us and we will get back to you!</p>
    </div>
    <div>
      <div class="d-flex justify-content-center align-items-center">
        <button
          type="submit"
          class="btn btn-enquire px-4"
          routerLink="/enquiry"
        >
          Enquire Now
        </button>
      </div>
    </div>
  </div>
</section>
<footer class="text-white">
  <div class="container">
    <div class="row py-5">
      <div class="col-lg-3 col-md-6">
        <div class="mb-3">
          <a routerLink="/"
            ><img
              src="../../../assets/footerlogo.svg"
              alt="Logo"
              class="mb-2 footerlogo"
          /></a>
        </div>
        <div class="social-icons gap-2">
          <a href="https://www.facebook.com/JNARDDC/" target="_blank"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.1053 14.0397V18.8747C12.1053 18.945 12.1645 19 12.2401 19H14.1711C14.2467 19 14.3059 18.945 14.3059 18.8747V13.9603H15.7072C15.7763 13.9603 15.8355 13.9114 15.8421 13.8441L15.977 12.3649C15.9836 12.2916 15.9211 12.2274 15.8421 12.2274H14.3059V11.176C14.3059 10.9285 14.5197 10.7298 14.7862 10.7298H15.8651C15.9408 10.7298 16 10.6748 16 10.6045V9.1253C16 9.05501 15.9408 9 15.8651 9H14.0395C12.9704 9 12.102 9.80685 12.102 10.8001V12.2274H11.1349C11.0592 12.2274 11 12.2824 11 12.3527V13.8319C11 13.9022 11.0592 13.9572 11.1349 13.9572H12.102V14.0367L12.1053 14.0397Z"
                fill="white"
              />
              <rect
                x="0.5"
                y="0.5"
                width="27"
                height="27"
                rx="13.5"
                stroke="white"
              /></svg
          ></a>
          <a href="https://twitter.com/JnarddcMines" target="_blank"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <g clip-path="url(#clip0_2282_2200)">
                <path
                  d="M0.5 14C0.5 6.54442 6.54442 0.5 14 0.5C21.4556 0.5 27.5 6.54442 27.5 14C27.5 21.4556 21.4556 27.5 14 27.5C6.54442 27.5 0.5 21.4556 0.5 14Z"
                  stroke="white"
                />
                <path
                  d="M14.9514 13.2343L18.6741 9H17.7919L14.5595 12.6766L11.9777 9H9L12.9041 14.5597L9 19H9.88222L13.2958 15.1174L16.0223 19H19L14.9514 13.2343ZM10.2001 9.64985H11.5551L17.7923 18.3797H16.4373L10.2001 9.64985Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_2282_2200">
                  <rect width="28" height="28" fill="white" />
                </clipPath>
              </defs></svg
          ></a>
          <a href="https://www.instagram.com/jnarddc/" target="_blank"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <path
                d="M16.6298 10.8398C16.306 10.8398 16.0408 11.1022 16.0408 11.4288C16.0408 11.7554 16.3032 12.0179 16.6298 12.0179C16.9565 12.0179 17.2189 11.7554 17.2189 11.4288C17.2189 11.1022 16.9565 10.8398 16.6298 10.8398ZM14.0167 11.5935C12.6544 11.5935 11.5461 12.7018 11.5461 14.0642C11.5461 15.4266 12.6544 16.5349 14.0167 16.5349C15.3791 16.5349 16.4874 15.4266 16.4874 14.0642C16.4874 12.7018 15.3791 11.5935 14.0167 11.5935ZM14.0167 15.6471C13.1429 15.6471 12.4338 14.938 12.4338 14.0642C12.4338 13.1904 13.1429 12.4813 14.0167 12.4813C14.8906 12.4813 15.5997 13.1904 15.5997 14.0642C15.5997 14.938 14.8906 15.6471 14.0167 15.6471ZM19 12.0123C19 10.3484 17.6516 9 15.9877 9H12.0123C10.3484 9 9 10.3484 9 12.0123V15.9877C9 17.6516 10.3484 19 12.0123 19H15.9877C17.6516 19 19 17.6516 19 15.9877V12.0123ZM18.0564 15.9877C18.0564 17.1295 17.1295 18.0564 15.9877 18.0564H12.0123C10.8705 18.0564 9.94361 17.1295 9.94361 15.9877V12.0123C9.94361 10.8705 10.8705 9.94361 12.0123 9.94361H15.9877C17.1295 9.94361 18.0564 10.8705 18.0564 12.0123V15.9877Z"
                fill="white"
              />
              <rect
                x="0.5"
                y="0.5"
                width="27"
                height="27"
                rx="13.5"
                stroke="white"
              /></svg
          ></a>
          <a
            href="https://www.youtube.com/channel/UCZeiviEmj05FXzWEOvvd53g"
            target="_blank"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <path
                d="M19 12.177C19 10.9752 18.0249 10 16.823 10H11.177C9.97515 10 9 10.9752 9 12.177V14.823C9 16.0248 9.97515 17 11.177 17H16.823C18.0249 17 19 16.0248 19 14.823V12.177ZM15.4379 13.6335L13.1863 14.8696C13.087 14.9224 13 14.8509 13 14.7391V12.205C13 12.0932 13.0901 12.0217 13.1894 12.0776L15.4565 13.3789C15.5559 13.4348 15.5404 13.5807 15.4379 13.6366V13.6335Z"
                fill="white"
              />
              <rect
                x="0.5"
                y="0.5"
                width="27"
                height="27"
                rx="13.5"
                stroke="white"
              /></svg
          ></a>
          <a
            href="https://www.threads.net/@jnarddc?xmt=AQGz_NAMJTlGAJkbe20x0O67rQfhrRYz7u-nKjOQypcIxw"
            target="_blank"
            ><img src="../../../assets/images/threads.svg" alt="" srcset=""
          /></a>
        </div>

        <div class="Visitors mb-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_1299_731"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1299_731)">
              <path
                d="M1 20V17.2C1 16.6333 1.14583 16.1125 1.4375 15.6375C1.72917 15.1625 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6458 5.75 13.3875C6.81667 13.1292 7.9 13 9 13C10.1 13 11.1833 13.1292 12.25 13.3875C13.3167 13.6458 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2708 15.1625 16.5625 15.6375C16.8542 16.1125 17 16.6333 17 17.2V20H1ZM19 20V17C19 16.2667 18.7958 15.5625 18.3875 14.8875C17.9792 14.2125 17.4 13.6333 16.65 13.15C17.5 13.25 18.3 13.4208 19.05 13.6625C19.8 13.9042 20.5 14.2 21.15 14.55C21.75 14.8833 22.2083 15.2542 22.525 15.6625C22.8417 16.0708 23 16.5167 23 17V20H19ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM19 8C19 9.1 18.6083 10.0417 17.825 10.825C17.0417 11.6083 16.1 12 15 12C14.8167 12 14.5833 11.9792 14.3 11.9375C14.0167 11.8958 13.7833 11.85 13.6 11.8C14.05 11.2667 14.3958 10.675 14.6375 10.025C14.8792 9.375 15 8.7 15 8C15 7.3 14.8792 6.625 14.6375 5.975C14.3958 5.325 14.05 4.73333 13.6 4.2C13.8333 4.11667 14.0667 4.0625 14.3 4.0375C14.5333 4.0125 14.7667 4 15 4C16.1 4 17.0417 4.39167 17.825 5.175C18.6083 5.95833 19 6.9 19 8ZM3 18H15V17.2C15 17.0167 14.9542 16.85 14.8625 16.7C14.7708 16.55 14.65 16.4333 14.5 16.35C13.6 15.9 12.6917 15.5625 11.775 15.3375C10.8583 15.1125 9.93333 15 9 15C8.06667 15 7.14167 15.1125 6.225 15.3375C5.30833 15.5625 4.4 15.9 3.5 16.35C3.35 16.4333 3.22917 16.55 3.1375 16.7C3.04583 16.85 3 17.0167 3 17.2V18ZM9 10C9.55 10 10.0208 9.80417 10.4125 9.4125C10.8042 9.02083 11 8.55 11 8C11 7.45 10.8042 6.97917 10.4125 6.5875C10.0208 6.19583 9.55 6 9 6C8.45 6 7.97917 6.19583 7.5875 6.5875C7.19583 6.97917 7 7.45 7 8C7 8.55 7.19583 9.02083 7.5875 9.4125C7.97917 9.80417 8.45 10 9 10Z"
                fill="white"
              />
            </g>
          </svg>
          <span class="ms-2">Visitors: {{ visitorCount }}</span>
        </div>
        <div class="updated mb-2">
          Last updated: {{ dataSource | date: "dd-MM-yy" }}
        </div>
      </div>

      <!-- Links Section -->
      <div class="col-lg-2 col-md-6 footer-links">
        <div>
          <h5>Recycling Promotion</h5>
          <div><a routerLink="/about-us">Recycling Promotion Division</a></div>
          <div><a routerLink="/secretary-message">Secretary's Message</a></div>
          <div>
            <a href="https://mines.gov.in/webportal/home" target="_blank"
              >Ministry of Mines</a
            >
          </div>
          <div><a routerLink="/vision-mission">Our Vision</a></div>
          <div><a routerLink="/whoswho">Who's Who</a></div>
        </div>
        <div class="mt-3">
          <h5>Ministry of Mines</h5>
          <div>
            <a
              href="../../../assets/pdf/MoM-S&T R&D Projects.pdf"
              target="_blank"
              >S&T R&D Projects​</a
            >
          </div>
          <div>
            <a
              href="../../../assets/pdf/MoM-S&T PRISM Projects.pdf"
              target="_blank"
              >S&T PRISM Projects</a
            >
          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-6 footer-links mt-4 mt-md-0">
        <h5>Other Links</h5>
        <div>
          <a href="https://jnarddc.gov.in/en/rti/rti.aspx" target="_blank"
            >Right to Information</a
          >
        </div>
        <div><a routerLink="/faq">FAQs</a></div>
      </div>

      <div class="col-lg-2 col-md-6 footer-links mb-4 mt-3 mt-md-0">
        <h5>Important Links</h5>
        <div><a routerLink="/feedback">Feedback</a></div>
        <!-- <div><a (click)="highlightSection('targetSection')">Contact Us</a></div> -->
        <div><a routerLink="/copyright">Copyright Policy</a></div>
        <div><a routerLink="/hyperlinking">Hyper Linking Policy</a></div>
        <div><a routerLink="/accessibility">Accessibility Statement</a></div>
        <div>
          <a
            href="../../../assets/pdf/Citizens_Charter.pdf"
            target="_blank"
            rel="noopener noreferrer"
            >Citizen's Charter</a
          >
        </div>
        <div>
          <a
            href="https://jnarddc.gov.in/en/tenders/tenders.aspx"
            target="_blank"
            rel="noopener noreferrer"
            >Tenders</a
          >
        </div>
        <div>
          <a
            href="https://jnarddc.gov.in/en/opputunities/Regular.aspx"
            target="_blank"
            rel="noopener noreferrer"
            >Careers</a
          >
        </div>
      </div>
      <!-- Contact Us Section -->
      <div class="col-lg-3 col-md-6 footer-links mt-4 mt-md-0">
        <h5>
          Jawaharlal Nehru Aluminium Research Development and Design Centre,
          Opposite wadi police station, Amravati Road, Wadi, Nagpur - 440 023,
          India
        </h5>
        <img
          src="../../../assets/minefooter.svg"
          alt="Logo"
          class="mb-2 footermine mt-4"
        />
      </div>
    </div>
  </div>
  <div class="copyright">
    <div
      class="container d-flex justify-content-between align-items-center flex-wrap gap-2"
    >
      <p class="mb-0">
        Copyright © 2025 - All Rights Reserved. Jawaharlal Nehru Aluminium
        Research Development & Design Centre
      </p>
      <a routerLink="/terms" class="text-white mx-2 text-decoration-none"
        >Terms & Conditions</a
      >
      <a routerLink="/policy" class="text-white mx-2 text-decoration-none"
        >Privacy Policy</a
      >
    </div>
  </div>
</footer>
